(ns manage.feed-lookup-table.db
  (:require [common.db.table.backend :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]
            [re-frame.core :as rf]))

(def backend
  (map->InMemoryBackend {}))

(register-table
 {:namespace :table.feed-lookup
  :value-sub [:form.feed-importer/mapped-fields]
  :initial-page {}
  :initial-search {}
  :initial-sort {}
  :backend backend})

(register-table
 {:namespace :table.content-lookup
  :value-sub [:form.content-variant/lookup-fields]
  :initial-page {}
  :initial-search {}
  :initial-sort {}
  :backend backend})

(rf/reg-sub :table.feed-lookup/latlon-disabled?
  :<- [:form.feed-lookup/value :settings]
  (fn [settings [_ fieldname]]
    ;; only one latlon field can be selected at a time
    (-> settings
        (dissoc fieldname)
        (vals)
        (->> (some :latlon)))))

(rf/reg-sub :table.feed-lookup/postcode-disabled?
  :<- [:form.feed-lookup/value :settings]
  (fn [settings [_ fieldname]]
    ;; only one postcode field can be selected at a time
    (-> settings
        (dissoc fieldname)
        (vals)
        (->> (some :postcode)))))
